import { useEffect, useState } from 'react';

import { AdminHistoryTypes, AdminHistoryTypesList } from 'constants/check-history-types';
import Moment from 'react-moment';

import { AnimatedModal } from 'components/AnimatedModal/AnimatedModal';
import { Comments } from 'components/Comments/Comments';

import { useLazyGetInternalCheckHistoryQuery } from 'api/candidate-checks-api';

export const CandidateCheckNotesModal = ({
  visible,
  title = 'Notes',
  onClose = () => {},
  checkId = null,
}) => {
  const [getInternalCheckHistory] = useLazyGetInternalCheckHistoryQuery();

  const [notes, setNotes] = useState([]);

  const getNotes = async () => {
    try {
      const { result } = await getInternalCheckHistory({ id: checkId }).unwrap();
      setNotes(result || []);
    } catch (error) {
      console.error('Failed to fetch notes:', error);
      setNotes([]);
    }
  };

  useEffect(() => {
    if (visible && checkId) {
      getNotes();
    }
  }, [visible, checkId]);

  const handleClose = () => {
    setNotes([]);
    onClose();
  };

  return (
    <AnimatedModal visible={visible} onClose={handleClose} title={title} icon="edit">
      <div className="d-flex flex-column u-gap-large u-max-height-400 u-min-height-150 u-overflow-y--auto u-overflow-hidden u-padding--small u-padding-top">
        {(notes || []).length > 0 ? (
          (notes || []).map(note => {
            const supportUserName = note?.user_name || 'Admin';
            return (
              <Comments
                key={note?.id}
                title={supportUserName}
                superText={note?.sub_check_id ? 'Sub Check' : 'Check'}
                caption={<Moment format="hh:mm DD/MM/YYYY ">{note?.created_at}</Moment>}
                initials={supportUserName?.charAt(0).toUpperCase() || 'A'}
                tooltip={supportUserName}
                comment={note?.message}
                tag={AdminHistoryTypes[note?.type]?.title}
                tagColor={AdminHistoryTypes[note?.type]?.color}
                tagValue={note?.type}
                tagOptions={AdminHistoryTypesList}
                edited={note?.modified_at}
                metadata={note?.metadata}
                allowActions={false}
              />
            );
          })
        ) : (
          <div className="text-muted text-center py-3">No notes available.</div>
        )}
      </div>
    </AnimatedModal>
  );
};
